import {createAsyncThunk} from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";

export const fetchIsServerDown = createAsyncThunk<string>(
  "appInfo/fetchIsServerDown",
  async () => {
    try {
      const response = await axiosInstance.get('/server-status');

      return response.status === 200
    } catch (error: any) {
      return error.message;
    }
  }
);
